<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('saleContract.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('saleContract.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div
          class="d-flex justify-content-between ts-items-center ts-whitespace-no-wrap ts-space-x-3"
        >
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
              @change="fetchData()"
            />
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input
              v-tooltip="$t('saleContract.search')"
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('employeeProfile.branch') }}</label>
                  <ts-branch-filter
                    @filter="branchFilter" 
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'contract_date',
          }"
        >
          <template v-slot="{ record }">

            <td class="ts-whitespace-no-wrap">
              {{ record.branch.branch_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.contract_no }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.customer.customer_name }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.project_name }}</td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{ record.vat_rate }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{ record.vat_amount }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{ record.total_exclude_vat }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{ record.grand_total }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{ record.created_by.name }}
            </td>
            <td class="text-center ts-space-x-3">
              <a
                href="#"
                v-tooltip="$t('deliveryOrder.reprint')"
                class="text-primary text-red"
                @click.prevent="previewPdf(record)"
              >
                <i class="fas fa-file-pdf"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
            <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
        <ts-preview-pdf v-model="waiting" :src="src" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import Reason from './components/reason_delete'

export default {
  name: 'saleContract',
  components: {
    Reason,
  },
  data() {
    return {
      loading: false,
      waiting: false,
      src: null,
      show_pdf: false,
      model: {
        deleted_reason: null
      },
      errors: new Errors(),
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('wholesale/saleContract', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.wholesale.saleContract.search
      },
      set(newValue) {
        this.$store.commit('wholesale/saleContract/SET_SEARCH', newValue)
        this.$store.commit('wholesale/saleContract/RESET_CURRENT_PAGE')
      },
    },
    dateRange: {
      get() {
        return this.$store.state.wholesale.saleContract.dateRange
      },
      set(newValue) {
        this.$store.commit('wholesale/saleContract/SET_DATE_RANGE', newValue)
      },
    },
    columns() {
      return [
        { name: this.$t('saleContract.branchName') },
        { name: this.$t('saleContract.contractNo') },
        { name: this.$t('saleContract.customer') },
        { name: this.$t('saleContract.projectName') },
        { name: this.$t('saleContract.vatRate'), style: 'text-align:right' },
        { name: this.$t('saleContract.vatAmount'), style: 'text-align:right' },
        {
          name: this.$t('saleContract.totalExcludevat'),
          style: 'text-align:right',
        },
        {
          name: this.$t('saleContract.grandTotal'),
          style: 'text-align:right',
        },
        {
          name: this.$t('saleContract.createdBy'),
          style: 'text-align:right',
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:7%',
        },
      ]
    },
  },
  methods: {
    addNew() {
      this.$router.push({ name: 'sale-contract-create' })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('wholesale/saleContract/fetch', { ...attributes })
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('wholesale/saleContract/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'sale-contract-edit',
        params: { id: record.contract_id },
      })
    },
    deleteRecord(record) {
      this.model.deleted_reason = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('saleContract.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.$store.dispatch('wholesale/saleContract/destroy', {
            id: record.contract_id,
            data: this.model
          })
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    },
    branchFilter(value){
      this.$store.commit('wholesale/saleContract/SET_BRANCH_ID', value)
      this.fetchData()
    },
    previewPdf(record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('wholesale/saleContract/previewPdf', record.contract_id)
        .then((response) => {
          this.src = response.url
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/saleContract/RESET_STATE')
    next()
  },
}
</script>

<style scoped>
</style>